import { combineReducers } from 'redux';
import { loadingBarReducer as loadingBar } from 'react-redux-loading-bar';

import authentication, { AuthenticationState } from './authentication';
import applicationProfile, { ApplicationProfileState } from './application-profile';

import administration, { AdministrationState } from 'app/modules/administration/administration.reducer';
import userManagement, { UserManagementState } from 'app/modules/administration/user-management/user-management.reducer';
import register, { RegisterState } from 'app/modules/account/register/register.reducer';
import activate, { ActivateState } from 'app/modules/account/activate/activate.reducer';
import password, { PasswordState } from 'app/modules/account/password/password.reducer';
import settings, { SettingsState } from 'app/modules/account/settings/settings.reducer';
import passwordReset, { PasswordResetState } from 'app/modules/account/password-reset/password-reset.reducer';
// prettier-ignore
import bankingUser, {
  BankingUserState
} from 'app/entities/banking-user/banking-user.reducer';
// prettier-ignore
import bankingUserProfile, {
  BankingUserProfileState
} from 'app/entities/banking-user-profile/banking-user-profile.reducer';
// prettier-ignore
import ibftBanks, {
  IbftBanksState
} from 'app/entities/ibft-banks/ibft-banks.reducer';
// prettier-ignore
import ipCapture, {
  IpCaptureState
} from 'app/entities/ip-capture/ip-capture.reducer';
// prettier-ignore
import otpSms, {
  OtpSmsState
} from 'app/entities/otp-sms/otp-sms.reducer';
// prettier-ignore
import billingCategory, {
  BillingCategoryState
} from 'app/entities/billing-category/billing-category.reducer';
// prettier-ignore
import institutes, {
  InstitutesState
} from 'app/entities/institutes/institutes.reducer';
// prettier-ignore
import beneficiaries, {
  BeneficiariesState
} from 'app/entities/beneficiaries/beneficiaries.reducer';
// prettier-ignore
import scheduledPayments, {
  ScheduledPaymentsState
} from 'app/entities/scheduled-payments/scheduled-payments.reducer';
// prettier-ignore
import scheduledPaymentAttempts, {
  ScheduledPaymentAttemptsState
} from 'app/entities/scheduled-payment-attempts/scheduled-payment-attempts.reducer';
// prettier-ignore
import passwordHistory, {
  PasswordHistoryState
} from 'app/entities/password-history/password-history.reducer';
// prettier-ignore
import serviceCategory, {
  ServiceCategoryState
} from 'app/entities/service-category/service-category.reducer';
// prettier-ignore
import serviceCompanies, {
  ServiceCompaniesState
} from 'app/entities/service-companies/service-companies.reducer';
// prettier-ignore
import notificationTemplate, {
  NotificationTemplateState
} from 'app/entities/notification-template/notification-template.reducer';
// prettier-ignore
import securityQuestion, {
  SecurityQuestionState
} from 'app/entities/security-question/security-question.reducer';
// prettier-ignore
import securityAnswer, {
  SecurityAnswerState
} from 'app/entities/security-answer/security-answer.reducer';
/* jhipster-needle-add-reducer-import - JHipster will add reducer here */

export interface IRootState {
  readonly authentication: AuthenticationState;
  readonly applicationProfile: ApplicationProfileState;
  readonly administration: AdministrationState;
  readonly userManagement: UserManagementState;
  readonly register: RegisterState;
  readonly activate: ActivateState;
  readonly passwordReset: PasswordResetState;
  readonly password: PasswordState;
  readonly settings: SettingsState;
  readonly bankingUser: BankingUserState;
  readonly bankingUserProfile: BankingUserProfileState;
  readonly ibftBanks: IbftBanksState;
  readonly ipCapture: IpCaptureState;
  readonly otpSms: OtpSmsState;
  readonly billingCategory: BillingCategoryState;
  readonly institutes: InstitutesState;
  readonly beneficiaries: BeneficiariesState;
  readonly scheduledPayments: ScheduledPaymentsState;
  readonly scheduledPaymentAttempts: ScheduledPaymentAttemptsState;
  readonly passwordHistory: PasswordHistoryState;
  readonly serviceCategory: ServiceCategoryState;
  readonly serviceCompanies: ServiceCompaniesState;
  readonly notificationTemplate: NotificationTemplateState;
  readonly securityQuestion: SecurityQuestionState;
  readonly securityAnswer: SecurityAnswerState;
  /* jhipster-needle-add-reducer-type - JHipster will add reducer type here */
  readonly loadingBar: any;
}

const rootReducer = combineReducers<IRootState>({
  authentication,
  applicationProfile,
  administration,
  userManagement,
  register,
  activate,
  passwordReset,
  password,
  settings,
  bankingUser,
  bankingUserProfile,
  ibftBanks,
  ipCapture,
  otpSms,
  billingCategory,
  institutes,
  beneficiaries,
  scheduledPayments,
  scheduledPaymentAttempts,
  passwordHistory,
  serviceCategory,
  serviceCompanies,
  notificationTemplate,
  securityQuestion,
  securityAnswer,
  /* jhipster-needle-add-reducer-combine - JHipster will add reducer here */
  loadingBar
});

export default rootReducer;
